import { render, staticRenderFns } from "./participants-diff-popover.vue?vue&type=template&id=25b9bdee&scoped=true"
import script from "./participants-diff-popover.vue?vue&type=script&lang=js"
export * from "./participants-diff-popover.vue?vue&type=script&lang=js"
import style0 from "./participants-diff-popover.vue?vue&type=style&index=0&id=25b9bdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9bdee",
  null
  
)

export default component.exports